import IconSelectButton from '../IconSelectButton.jsx';
import TextInput from '../TextInput';
import { SlidingPanelPage } from '../SlidingSidePanel.jsx';
import UnsplashPicker from '../UnsplashPicker.jsx';
import { useEffect, useState } from 'react';
import ColorPickerGrid from '../ColorPickerGrid.jsx';
import { PhotoIcon } from '@heroicons/react/24/outline/index.js';
import ToggleablePanel from './ToggleablePanel.jsx';
import FileUpload from '~/components/FileUpload';
import Loading from '~/components/Loading';

const StylesHeaderCover = ({ styles, setStyles }) => {
    const [showUnsplash, setShowUnsplash] = useState(false);
    const [showColorPicker, setShowColorPicker] = useState(false);
    const isImageSelected = !!styles?.headerImage;
    const isColorSelected = !!styles?.headerColor;

    useEffect(() => {
        if (
            (isImageSelected || isColorSelected) &&
            typeof styles?.fullPageImage === 'undefined'
        ) {
            setStyles({
                ...styles,
                fullPageImage: true,
            });
        }
    }, [isImageSelected, isColorSelected, styles?.fullPageImage]);

    return (
        <>
            <div className="panel-label">Background</div>
            <div className="flex items-center gap-x-4">
                <IconSelectButton
                    icon={
                        <>
                            {!!styles?.headerImage && (
                                <>
                                    {/* if header image is a string, render it. if it is not a string then show a loading indiactor */}
                                    {typeof styles?.headerImage === 'string' && (
                                        <img src={styles?.headerImage || ''} />
                                    )}
                                    {typeof styles?.headerImage !== 'string' && (
                                        <Loading />
                                    )}
                                </>
                            )}
                            {!styles?.headerImage && (
                                <div className="min-h-[73px] h-full bg-gray-100 flex items-center justify-center">
                                    <PhotoIcon className={'w-16 h-16'} />
                                </div>
                            )}
                        </>
                    }
                    label="Image"
                    className="w-32 bg-gray-300"
                    isSelected={isImageSelected}
                    onClick={() => setShowUnsplash(true)}
                />

                <IconSelectButton
                    icon={
                        <div
                            className="w-full min-h-[73px] h-full"
                            style={{
                                backgroundColor:
                                    styles?.headerColor || '#CCCCCC',
                            }}
                        >
                            &nbsp;
                        </div>
                    }
                    label="Color"
                    className="w-32 bg-gray-300"
                    isSelected={isColorSelected}
                    onClick={() => setShowColorPicker(true)}
                />
            </div>
            {(isImageSelected || isColorSelected) && (
                <div className="mt-4">
                    {isImageSelected && !styles?.fullPageImage && (
                        <>
                            <div className="panel-label">Image Position</div>
                            <TextInput
                                value={styles?.headerImagePosition || ''}
                                onChange={newValue =>
                                    setStyles({
                                        ...styles,
                                        headerImagePosition: newValue,
                                    })
                                }
                                label=""
                                type="range"
                                className="max-w-64"
                            />
                        </>
                    )}

                    <div className="panel-label mt-4">Size</div>
                    <ToggleablePanel
                        enabled={styles?.fullPageImage}
                        setEnabled={newValue =>
                            setStyles({ ...styles, fullPageImage: newValue })
                        }
                    >
                        <div className="text-gray-500 text-sm">
                            {isImageSelected
                                ? 'Image covers full page'
                                : 'Color covers full page'}
                        </div>
                    </ToggleablePanel>
                </div>
            )}
            <SlidingPanelPage
                isOpen={showUnsplash}
                onClose={() => setShowUnsplash(false)}
                title="Background Image"
            >
                <UnsplashPicker
                    onChange={newValue => {
                        setStyles({
                            ...styles,
                            headerImage: newValue,
                            headerColor: '',
                        });

                        if (newValue === styles?.headerImage) {
                            setShowUnsplash(false);
                        }
                    }}
                    value={styles?.headerImage || ''}
                />

                <div className="panel-label mt-6">Upload Custom Image</div>
                <FileUpload
                    onChange={newValue => {
                        setStyles({
                            ...styles,
                            headerImage: newValue,
                            headerColor: '',
                        });
                        setShowUnsplash(false);
                    }}
                    value={styles?.headerImage || ''}
                    className="mb-4"
                />
            </SlidingPanelPage>

            <SlidingPanelPage
                isOpen={showColorPicker}
                onClose={() => setShowColorPicker(false)}
                title="Background Color"
            >
                <ColorPickerGrid
                    value={styles?.headerColor || ''}
                    onChange={newValue => {
                        setStyles({
                            ...styles,
                            headerImage: '',
                            headerColor: newValue,
                        });
                    }}
                />
            </SlidingPanelPage>
        </>
    );
};

export default StylesHeaderCover;
